import _ from 'underscore';
import { ACTIVE_STATUS } from './constants';

export const getShowNoActiveCampaignCouponAlert = (coupon, data, selectionData, callback) => {
  let showNoActiveCampaignCouponAlert;
  let campaignIds = null;
  let campaignMap = null;
  if (!coupon || _.isEmpty(selectionData)) {
    showNoActiveCampaignCouponAlert = false;
  } else {
    campaignMap = {};
    _.each(data, (obj) => {
      campaignMap[obj.Id] = obj.Status;
    });
    campaignIds = _.union(
      selectionData.selectedCampaignIds,
      selectionData.selectedWithActiveOnly,
      _.map(
        _.keys(selectionData.selectedAdGroupMap),
        campaignId => parseInt(campaignId, 10)
      )
    );

    showNoActiveCampaignCouponAlert = !_.isEmpty(campaignIds) && !_.any(
      campaignIds,
      campaignId => campaignMap[campaignId] === ACTIVE_STATUS
    );
  }

  if (callback) callback(showNoActiveCampaignCouponAlert);

  return showNoActiveCampaignCouponAlert;
};
